//
//
//
//
//
//
//
//

export default {
  name: 'maps',
  components: {
  },
  data () {
    return {
      lat:'',
      lng:'',
      address:'',
      confirmStatus:false,
      src:''
    }
  },
  created(){
    this.lat = this.$route.params.latitude;
    this.lng = this.$route.params.longitude;
    this.src = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=X4PBZ-RCUC4-36BUD-FCVYG-OWXRQ-OSBPM&referer=fengchao';
    // this.src = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&coord='+this.lat+','+this.lng+'&key=X4PBZ-RCUC4-36BUD-FCVYG-OWXRQ-OSBPM&referer=fengchao';
    // this.src = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&coord='+this.lat+','+this.lng+'&key=3RXBZ-XDHC4-76FUE-X3T6K-7VOJK-KEFFP&referer=washcollect';
    // this.src = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&coord='+this.lat+','+this.lng+'&key=3RXBZ-XDHC4-76FUE-X3T6K-7VOJK-KEFFP&referer=washcollect';
    console.log(this.src);
  },
  // beforeRouteLeave(to, from, next) {
  //   to.meta.keepAlive = true; 
  //   next();
  // },
  mounted(){
    let that = this;
    this.$func.setSession('address','');
     window.addEventListener('message', function(event) {
      //  console.log(event);

        var loc = event.data;
        if (loc && loc.module == 'locationPicker') {
          that.$func.setSession('address',JSON.stringify(loc));
        }
    }, false);
  },
  methods:{
    confirm(){
      if(!this.$func.getSession('address')){
        this.$func.showToast('请选择位置信息');
        return false;
      }
      this.$router.back(-1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/maps.vue